"use client";

import { Container } from "@/src/components/container";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";

import SwiperCore, { Autoplay } from "swiper";
import { useDomReady } from "@/src/hooks/dom-ready";
import { IsoFooterSectionProps } from "..";
import { IsoFooterCard } from "@/src/components/cards/isofooter/v3";

SwiperCore.use([Autoplay]);

export function IsoFooterCardsCaraousl({
   cards,
}: Pick<IsoFooterSectionProps, "cards">) {
   const isDomReady = useDomReady();

   return (
      <>
         {isDomReady && (
            <Container>
               {cards && cards.length > 0 && (
                  <div className="">
                     <Swiper
                        className="w-96 !overflow-visible"
                        speed={400}
                        loop
                        spaceBetween={50}
                        slidesPerView={3}
                        autoplay={{
                           delay: 2000, // Delay between transitions (in milliseconds)
                           disableOnInteraction: false, // Keeps autoplay running even after interaction
                        }}
                     >
                        {cards.map((card, i) => (
                           <SwiperSlide key={i}>
                              <IsoFooterCard {...card} />
                           </SwiperSlide>
                        ))}
                     </Swiper>
                  </div>
               )}
            </Container>
         )}
      </>
   );
}
